export function getColorInitial(
    color?: "Blue" | "Green" | "Magenta" | "Purple" | "Red" | "Teal" | "Yellow",
    randomIfUndefined = false
): string | undefined {
    //return initial letter
    if (color) return color.charAt(0);

    //by default stop here
    if (!randomIfUndefined) return;

    //return random color
    //TODO: get design approval to add Purple (used by UiNavLink)
    const colors = ["B", "G", "M", "R", "T", "Y"];
    const randomIndex = Math.floor(Math.random() * colors.length);
    return colors[randomIndex];
}
